import $ from 'jquery'
import { GeoJSON } from 'ol/format'
import Feature from 'ol/Feature'
export default {
  layers: {
    Layer: function(layer) {
      var enc = {
        opacity: layer.getOpacity()
      }
      return enc
    },
    Group: function(layer, proj) {
      var encs = []
      var subLayers = layer.getLayers()
      subLayers.forEach(function(subLayer) {
        if (subLayer.visible) {
          var enc = this.encoders.layers['Layer'].call(this, layer)
          var layerEnc = this.encodeLayer(subLayer, proj)
          if (layerEnc && layerEnc.layer) {
            $.extend(enc, layerEnc)
            encs.push(enc.layer)
          }
        }
      })
      return encs
    },
    Vector: function(layer, features) {
      var enc = this.encoders.layers['Layer'].call(this, layer)
      var format = new GeoJSON()
      var encStyles = {}
      var encFeatures = []
      var styleId = 0
      var hasLayerStyleFunction = !!(
        layer.getStyleFunction && layer.getStyleFunction()
      )

      features.forEach(
        function(feature) {
          var encStyle = {
            id: styleId
          }
          var styles = hasLayerStyleFunction
            ? layer.getStyleFunction()(feature)
            : Feature.defaultStyleFunction(feature)

          var geometry = feature.getGeometry()

          // Transform an ol.geom.Circle to a ol.geom.Polygon
          if (geometry.getType() === 'Circle') {
            var polygon = this.circleToPolygon(geometry)
            feature = new Feature(polygon)
          }

          var encJSON = format.writeFeatureObject(feature)
          if (!encJSON.properties) {
            encJSON.properties = {}
          } else if (encJSON.properties.Style) {
            // Fix https://github.com/geoadmin/mf-geoadmin3/issues/1213
            delete encJSON.properties.Style
          }

          if (encJSON.properties.olga_) {
            delete encJSON.properties.olga_
          }

          encJSON.properties._gx_style = styleId
          encFeatures.push(encJSON)

          if (styles && styles.length > 0) {
            $.extend(encStyle, this.transformToPrintLiteral(feature, styles[0]))
          }

          encStyles[styleId] = encStyle
          styleId++
        }.bind(this)
      )

      $.extend(enc, {
        type: 'Vector',
        styles: encStyles,
        styleProperty: '_gx_style',
        geoJson: {
          type: 'FeatureCollection',
          features: encFeatures
        },
        name: layer.bodId,
        opacity: layer.opacity != null ? layer.opacity : 1.0
      })
      return enc
    },
    WMTS: function(layer,_config) {
      var enc = this.encoders.layers['Layer'].call(this, layer)
      var source = layer.getSource()
      var tileGrid = source.getTileGrid()
      var url = source.getUrls()[0]
      $.extend(enc, {
        baseURL: this.prependHostnameToUrl(url),
        type: "WMTS",
        layer: source.getLayer(),
        format: source.getFormat(),
        matrixSet: source.getMatrixSet(),
        matrixIds: getLantmaterietMatrices(),
        style: source.getStyle(), 
        opacity: 1,
        requestEncoding: source.getRequestEncoding() || 'KVP',
        tileOrigin: tileGrid.getOrigin(),
        tileSize: tileGrid.getTileSize(),
        resolutions: tileGrid.getResolutions(),
        tileFullExtent: tileGrid.getExtent(),
        style: source.getStyle(),
        dimensions: [],
       
        version: source.getVersion(),
      })
      return enc
    },
    WMS: function(layer, config) {
      var url
      var enc = this.encoders.layers['Layer'].call(this, layer)

      var source = this.getLayerSource(layer)
      var params = source.getParams()
      var layers = params.LAYERS.split(',') || []

      if (source.getUrl) {
        url = source.getUrl()
      } else if (source.getUrls) {
        var sourceUrls = source.getUrls()
        url = sourceUrls[0]
      }

      url = this.prependHostnameToUrl(url)
      $.extend(enc, {
        type: 'WMS',
        baseURL: url,
        layers: layers,
        format: 'image/' + (config.format || 'png')
      })

      return enc
    }
  }
}

const getLantmaterietMatrices = () => ([{
  "resolution": 4096,
  "identifier": 0,
  "scaleDenominator": 14628571.42857142910361289978,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [4, 4],
  "tileSize": [256,256]
},
{
  "resolution": 2048,
  "identifier": 1,
  "scaleDenominator": 7314285.71428571455180644989,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [8, 8],
  "tileSize": [256,256]
},
{
  "resolution": 1024,
  "identifier": 2,
  "scaleDenominator": 3657142.85714285727590322495,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [16, 16],
  "tileSize": [256,256]
},
{
  "resolution": 512,
  "identifier": 3,
  "scaleDenominator": 1828571.42857142863795161247,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [32, 32],
  "tileSize": [256,256]
},
{
  "resolution": 256,
  "identifier": 4,
  "scaleDenominator": 914285.71428571431897580624,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [64, 64],
  "tileSize": [256,256]
},
{
  "resolution": 128,
  "identifier": 5,
  "scaleDenominator": 457142.85714285715948790312,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [128, 128],
  "tileSize": [256,256]
},
{
  "resolution": 64,
  "identifier": 6,
  "scaleDenominator": 228571.42857142857974395156,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [256, 256],
  "tileSize": [256,256]
},
{
  "resolution": 32,
  "identifier": 7,
  "scaleDenominator": 114285.71428571428987197578,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [512, 512],
  "tileSize": [256,256]
},
{
  "resolution": 16,
  "identifier": 8,
  "scaleDenominator": 57142.85714285714493598789,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [1024, 1024],
  "tileSize": [256,256]
},
{
  "resolution": 8,
  "identifier": 9,
  "scaleDenominator": 28571.42857142857246799394,
  "topLeftCorner" :[-1200000.000000,8500000.000000],
  "matrixSize": [2048, 2048],
  "tileSize": [256,256]
},
{
  "resolution": 4,
  "identifier": 10, 
  "scaleDenominator": 14285.71428571428623399697,
  "topLeftCorner": [-1200000.0, 8500000.0],
  "matrixSize": [4096, 4096],
  "tileSize": [256, 256]
},
{
  "resolution": 2,
  "identifier": 11, 
  "scaleDenominator": 7142.85714285714311699849, 
  "topLeftCorner": [-1200000.0, 8500000.0],
  "matrixSize": [8192, 8192],
  "tileSize": [256, 256]
},
{
  "resolution": 1,
  "identifier": 12, 
  "scaleDenominator": 3571.42857142857155849924, 
  "topLeftCorner": [-1200000.0, 8500000.0],
  "matrixSize": [16384, 16384],
  "tileSize": [256, 256]
},
{
  "resolution": 0.5,
  "identifier": 13, 
  "scaleDenominator": 1785.71428571428577924962, 
  "topLeftCorner": [-1200000.0, 8500000.0],
  "matrixSize": [32768, 32768],
  "tileSize": [256, 256]
}])
